<template>
    <div class="components-container">
        <div class="fromclass">
            <div style="border-bottom:2px solid #c8c8c8; text-align:center; height:50px;">
                <span style="color:#58666e; font-size:28px; font-weight:bold;">{{ title }}</span>
                <div style="float:right;">
                    <el-button @click="exportkcbz" type="success">导出</el-button>
                    <!-- <el-button v-if="gobackbuttonshow" @click="backtolastpage()" type="info">返回上一页</el-button> -->
                </div>
            </div>

            <div :style="innerDialog" class="scrollArea">
                <el-scrollbar style="height: 100%;" ref="elScrollbar">
                    <el-form :inline="true" class="small-space" :model="formData" label-position="right" label-width="190px" style='width: 100%; margin-left:0px;'>
                        <el-form-item label="编号：">
                            <el-input style="width:610px;margin-left: 20px;" :disabled="true" name="BH" v-model="BH"
                                autoComplete="on" maxlength="30"></el-input>
                        </el-form-item>
                        <el-form-item label="状态：">
                            <div v-if="courseStandardState == '0'" class="status" style="background-color: #808080">
                                未保存
                            </div>
                            <div v-else-if="courseStandardState == '1'" class="status" style="background-color: #e6a23c">
                                未提交
                            </div>
                            <div v-else-if="courseStandardState=='2'" class="status" style="background-color: #409eff">
                                待审核
                            </div>
                            <div v-else-if="courseStandardState == '3'" class="status" style="background-color: #67c23a">
                                审核通过
                            </div>
                            <div v-else-if="courseStandardState == '4'" class="status" style="background-color: #f56c6c">
                                审核驳回
                            </div>
                            <div v-else></div>
                        </el-form-item>
                        <el-form-item label="起效学年：">
                            <el-select v-model="dqxnxq" clearable placeholder="请选择" style="width:610px;margin-left: 20px;">
                                <el-option v-for="(item,index) in xnxq" :key="item.comboValue" :label="item.comboName" :value="item.comboValue"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="适用专业">
                            <el-select v-model="SYZY" clearable placeholder="请选择" style="width:610px;margin-left: 20px;"
                                filterable>
                                <el-option v-for="(item,index) in zy" :key="item.comboValue" :label="item.comboName"
                                    :value="item.comboValue"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="编制人">
                            <el-input style="width:610px;margin-left: 20px;" :disabled="true" name="BZR" v-model="BZR"
                                autoComplete="on" maxlength="30"></el-input>
                        </el-form-item>
                        <el-form-item label="编制日期">
                            <div class="block">
                                <el-date-picker style="width:610px;margin-left: 20px;" v-model="BZRQ" name="BZRQ" align="right"
                                    value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm" type="datetime"
                                    placeholder="日期">
                                </el-date-picker>
                            </div>
                        </el-form-item>
                        <el-form-item label="课程">
                            <el-input style="width:1340px;margin-left: 20px;" name="KC" v-model="KC" maxlength="30"></el-input>
                        </el-form-item>

                        <div class="fromtitle new1">课程性质</div>
                        <el-input id="KCXZ" type="textarea" name="KCXZ" v-model="KCXZ" rows="3"></el-input>
                        <div class="fromtitle new1">设计思路</div>
                        <el-input id="SJSL" type="textarea" name="SJSL" v-model="SJSL" rows="3"></el-input>
                        <div class="fromtitle new1">课程目标</div>
                        <el-input id="KCMB" type="textarea" style="margin-bottom: 20px;" name="KCMB" v-model="KCMB" rows="3"></el-input>

                        <el-table :data="tableData" :span-method="objectSpanMethod" stripe border
                            fit highlight-current-row height="600px" style="width: 100%;max-height:600px;"
                            :header-cell-style="{'font-weight': '900','color':'#58666e'}" ref="multipleTable">
                            <el-table-column :label="'工作任务 \n 一级知识点技能点'" prop="job" align="center" width="150"></el-table-column>
                            <el-table-column :label="'参考学时'" prop="time" align="center" width="100"></el-table-column>
                            <el-table-column :label="'技能与学习水平 \n 二级技能点'" prop="skill" align="center"></el-table-column>
                            <el-table-column :label="'技能与学习水平 \n 三级技能点'" align="center">
                                <template slot-scope="props">
                                    <el-table :data="props.row.slevellist" :show-header="false"
                                        align="center" stripe>
                                        <el-table-column align="center" prop="kk_mc"></el-table-column>
                                    </el-table>
                                </template>
                            </el-table-column>
                            <el-table-column :label="'知识与学习水平 \n 二级知识点'" prop="knowlage" align="center"></el-table-column>
                            <el-table-column :label="'知识与学习水平 \n 三级知识点'" align="center">
                                <template slot-scope="props">
                                    <el-table :data="props.row.klevellist" :show-header="false"
                                        align="center" stripe>
                                        <el-table-column align="center" prop="kk_mc"></el-table-column>
                                    </el-table>
                                </template>
                            </el-table-column>
                        </el-table>
                        <el-form-item label="总课时" style="height: 90px;margin-top: 25px;">
                            <el-input style="width:1000px;" :disabled="true" name="ZKS" v-model="ZKS" autoComplete="on"
                                maxlength="10"></el-input>
                        </el-form-item>
                        <div class="fromtitle new1">教学活动参考</div>
                        <el-input id="JXHDCK" type="textarea" name="JXHDCK" v-model="JXHDCK" rows="3"></el-input>

                        <el-form-item label="课程总学时">
                            <el-input style="width:1000px;" name="KCZXS" v-model="KCZXS" autoComplete="on" maxlength="30"></el-input>
                            <div class="zxstsy">{{zxsts}}</div>
                        </el-form-item>
                        <div style="margin-bottom: 30px;">
                            <div class="fromtitle new1">课程标准原件</div>
                            <el-col :span="3">
                                <span class="fileName">{{ filename }}</span>
                                <el-button size="small" type="primary" @click.stop="download" style="margin:10px 0 0 10px;">下载</el-button>

                            </el-col>
                        </div>
                    </el-form>
                </el-scrollbar>
            </div>
        </div>
    </div>
</template>

<script>
    import { globalConfig } from 'static/config'

    export default {
        props: ["courseStandardInfo", "KBBH"],
        data() {
            return {
                userCode: null,
                userName: null,
                courseStandardState: null,
                title: "课程标准",
                BH: "",
                ZT: "已发布",
                xnxq: [],
                dqxnxq: "",
                zy: [],
                SYZY: "",
                BZR: "",
                BZRGH: "", //编制人工号
                BZRQ: "",
                KC: "",
                KCXZ: "",
                SJSL: "",
                ZKS: "76",
                KCMB: "",
                KCNRYYQ: "",
                JXHDCK: "",
                KCZXS: "20",
                tableData: [],
                spanArr1: [],
                spanArr2: [],
                spanArr3: [],
                spanArr4: [],
                spanArr5: [],
                spanArr6: [],
                filename: "", //课程标准原件
                state: "", //当前状态
                zxsts: "", //总学时提示语
                kk_file: '',
                treeData: [], //树形结构信息
                bjr: "", //编辑人
                isLoading: false, //正在加载中
                formData: null,
                innerDialog: {
                    height: "750px",
                },
            }
        },
        mounted() {
            this.queryUserInfo();

            /* try {
                var data = location.href;
                data = '[{integrityurl:\"' + data + '\"}]'
                window.parent.postMessage(data, '*')
            } catch (e) {} */

            this.$nextTick().then(() => {
                this.innerDialog.height = window.innerHeight / 1.25 + "px";
                $(".el-dialog.is-fullscreen").css("overflow-y", "hidden");
            });
        },
        methods: {
            init(){
                if (this.KBBH != "" && this.KBBH != null && this.KBBH != undefined) {
                    this.BH = this.KBBH;
                } else {
                    this.BH = this.$route.params.kk_kcbzbh
                    //this.gobackbuttonshow = true;
                    if (document.referrer != "" && location.href != document.referrer) {
                        localStorage.setItem("kcbzgb", document.referrer);
                    }
                }

                this.KCNRYYQ = "说明：\n1.点击工作任务列，弹出工作任务、技能点、知识点的新建选项\n2.新建技能点时可选填对应知识点\n3.新建知识点时可选填对应技能点\n4.选择后将技能点和知识点进行关联，不选择时为单独的技能点或知识点\n5.单个二级技能点可对应多个二级知识点，单个二级知识点可对应多个二级技能点，但多个二级技能点不可对应多个二级知识点\n6.点击二级技能点列或二级知识点列，将新增对应技能或知识的学习水平\n";
                //this.JXHDCK="  本课程的教学活动设计是根据教学课程目标、学生实际动手操作为主；结合教学内容、教学实训设备等综合学习活动进行，以典型学习主题为载体，贯彻任务导向、项目驱动的基本理念，努力创设贴近楼宇智能化设备安装与调试实际工作岗位的学习环境和教学条件，以学生为主体、教师为主导，形成“做中学、学中做”一体的课堂教学活动。"
                this.loadzsdMsg();
                this.xnxqmsg();
                this.zymsg();
                this.loadMsg();
            },
            queryUserInfo() {
                this.$api.system.basic.userInfo({}).then((res) => {
                    if (res.data.data) {
                        this.userName = res.data.data.name;
                        this.userCode = res.data.data.phone;

                        this.init();
                    } else {
                        this.userRole = '访客';
                        this.$router.push('/login');
                    }
                }).catch((err) => {
                    console.log(err);
                });
            },
            /* @lbj
			 @2021 0513
			 @总学时验证	*/
            zxsyz(rpzxs) {
                if (rpzxs > this.KCZXS) {
                    this.zxsts = "学时不足，未达到人才培养方案的规定学时(" + rpzxs + ")";
                    $(".zxstsy").css('background', '#e7cf47');
                    $(".zxstsy").css('color', '#fff');
                } else if (rpzxs < this.KCZXS) {
                    this.zxsts = "学时过多，超出人才培养方案的规定学时(" + rpzxs + ")";
                    $(".zxstsy").css('background', '#ff2848');
                    $(".zxstsy").css('color', '#fff');
                } else {
                    this.zxsts = "";
                    $(".zxstsy").css('background', '#fff');
                }
            },
            download() {
                if (this.kk_file==null || this.kk_file=='') {
                    this.$alert("尚未上传课程标准原件", "提示", {
                        confirmButtonText: "确定",
                    });

                    return;
                }

                const fileUrl = globalConfig.HOST_PROXY_ADMIN + '/api/file/' + this.kk_file;
                let exist = this.isExistFile(fileUrl);
                if (exist) {
                    this.downloadFile(fileUrl, this.filename);
                } else {
                    this.$notify({
                        title: "错误",
                        message: "文件不存在，如有疑问请联系管理员！",
                        type: "error",
                        duration: 3000,
                    });
                }
            },
            downloadFile(url, fileName) {
                let x = new XMLHttpRequest();
                x.open("GET", url, true);
                x.responseType = 'blob';
                x.onload = function(e) {
                    var url = window.URL.createObjectURL(x.response)
                    var a = document.createElement('a');
                    a.href = url
                    a.download = fileName;
                    a.click()
                }
                x.send();
            },
            isExistFile(url) {
                if (url == null || url == undefined || url == "") {
                    return false;
                }
                let xmlhttp;
                if (window.XMLHttpRequest) {
                    xmlhttp = new XMLHttpRequest();
                } else {
                    xmlhttp = new ActiveXObject("Microsoft.XMLHTTP");
                }
                xmlhttp.open("GET", url, false);
                xmlhttp.send();
                if (xmlhttp.readyState == 4) {
                    if (xmlhttp.status == 200) return true;
                    //url存在
                    else if (xmlhttp.status == 404) return false;
                    //url不存在
                    else return false; //其他状态
                }
            },
            zymsg() {
                //专业下拉框
                this.$api.common.comboOption.major().then(response => {
                    this.zy = response.data.data.comboData;
                }).catch(error => {
                    console.log(error);
                });
            },
            //2021 0506 lbj 学年学期下拉框
            xnxqmsg() {
                this.$api.common.comboOption.year().then(response => {
                    this.xnxq = response.data.data.comboData;
                }).catch(error => {
                    console.log(error);
                });
            },
            //2021 0506 lbj 数据合并方法
            getSpanArr(data) {
                this.ZKS = 0;
                //this.KCZXS=0;
                for (var i = 0; i < data.length; i++) {
                    if (i === 0) {
                        this.spanArr1.push(1);
                        this.pos = 0
                        this.ZKS += parseInt(data[i].time);
                        //this.KCZXS+=parseInt(data[i].time);
                    } else {
                        // 判断当前元素与上一个元素是否相同
                        if (data[i].job === data[i - 1].job) {
                            this.spanArr1[this.pos] += 1;
                            this.spanArr1.push(0);
                        } else {
                            this.ZKS += parseInt(data[i].time);
                            //this.KCZXS+=parseInt(data[i].time);
                            this.spanArr1.push(1);
                            this.pos = i;
                        }
                    }
                }
                for (var i = 0; i < data.length; i++) {
                    if (i === 0) {
                        this.spanArr2.push(1);
                        this.pos = 0
                    } else {
                        // 判断当前元素与上一个元素是否相同
                        if (data[i].time === data[i - 1].time) {
                            this.spanArr2[this.pos] += 1;
                            this.spanArr2.push(0);
                        } else {
                            this.spanArr2.push(1);
                            this.pos = i;
                        }
                    }
                }
                for (var i = 0; i < data.length; i++) {
                    if (i === 0) {
                        this.spanArr3.push(1);
                        this.pos = 0
                    } else {
                        // 判断当前元素与上一个元素是否相同
                        if (data[i].skill != "" && data[i - 1].skill != "") {
                            if (data[i].skill === data[i - 1].skill) {
                                this.spanArr3[this.pos] += 1;
                                this.spanArr3.push(0);
                            } else {
                                this.spanArr3.push(1);
                                this.pos = i;
                            }
                        } else {
                            this.spanArr3.push(1);
                            this.pos = i;
                        }
                    }
                }
                //三级技能点
                for (var i = 0; i < data.length; i++) {
                    if (i === 0) {
                        this.spanArr4.push(1);
                        this.pos = 0
                    } else {
                        // 判断当前元素与上一个元素是否相同
                        if (data[i].slevellist.length != 0 && data[i - 1].slevellist.length != 0) {
                            //新增判断，如果没有任何二级则直接判断不相等 2021 0202 lbj
                            /* 						   console.log(data[i].slevellist[0].kk_mc);
                            						   console.log(data[i-1].slevellist[0].kk_mc);
                            						   console.log(data[i].slevellist[0].kk_sjkcnrbh);
                            						   console.log(data[i - 1].slevellist[0].kk_sjkcnrbh); */
                            if (data[i].slevellist[0].kk_sjkcnrbh === data[i - 1].slevellist[0].kk_sjkcnrbh) {
                                this.spanArr4[this.pos] += 1;
                                this.spanArr4.push(0);
                            } else {
                                this.spanArr4.push(1);
                                this.pos = i;
                            }
                        } else {
                            this.spanArr4.push(1);
                            this.pos = i;
                        }
                    }
                }
                for (var i = 0; i < data.length; i++) {
                    if (i === 0) {
                        this.spanArr5.push(1);
                        this.pos = 0
                    } else {
                        // 判断当前元素与上一个元素是否相同
                        if (data[i].knowlage != "" && data[i - 1].knowlage != "") {
                            if (data[i].knowlage === data[i - 1].knowlage) {
                                this.spanArr5[this.pos] += 1;
                                this.spanArr5.push(0);
                            } else {
                                this.spanArr5.push(1);
                                this.pos = i;
                            }
                        } else {
                            this.spanArr5.push(1);
                            this.pos = i;
                        }
                    }
                }
                //三级知识点
                for (var i = 0; i < data.length; i++) {
                    if (i === 0) {
                        this.spanArr6.push(1);
                        this.pos = 0
                    } else {
                        // 判断当前元素与上一个元素是否相同

                        if (data[i].klevellist.length != 0 && data[i - 1].klevellist.length != 0) {
                            //新增判断，如果没有任何二级则直接判断不相等 2021 0202 lbj
                            if (data[i].klevellist[0].kk_sjkcnrbh === data[i - 1].klevellist[0].kk_sjkcnrbh) {
                                this.spanArr6[this.pos] += 1;
                                this.spanArr6.push(0);
                            } else {
                                this.spanArr6.push(1);
                                this.pos = i;
                            }
                        } else {
                            this.spanArr6.push(1);
                            this.pos = i;
                        }
                    }
                }
            },
            objectSpanMethod({
                row,
                column,
                rowIndex,
                columnIndex
            }) {
                if (columnIndex === 0) {
                    const _row = this.spanArr1[rowIndex];
                    const _col = _row > 0 ? 1 : 0;
                    return {
                        rowspan: _row,
                        colspan: _col
                    }
                }

                if (columnIndex === 1) {
                    const _row = this.spanArr1[rowIndex];
                    const _col = _row > 0 ? 1 : 0;
                    return {
                        rowspan: _row,
                        colspan: _col
                    }
                }

                if (columnIndex === 2) {
                    const _row = this.spanArr3[rowIndex];
                    const _col = _row > 0 ? 1 : 0;
                    return {
                        rowspan: _row,
                        colspan: _col
                    }
                }

                if (columnIndex === 3) {
                    const _row = this.spanArr4[rowIndex];
                    const _col = _row > 0 ? 1 : 0;
                    return {
                        rowspan: _row,
                        colspan: _col
                    }
                }

                if (columnIndex === 4) {
                    const _row = this.spanArr5[rowIndex];
                    const _col = _row > 0 ? 1 : 0;
                    return {
                        rowspan: _row,
                        colspan: _col
                    }
                }

                if (columnIndex === 5) {
                    const _row = this.spanArr6[rowIndex];
                    const _col = _row > 0 ? 1 : 0;
                    return {
                        rowspan: _row,
                        colspan: _col
                    }
                }
            },
            /* @WHY
              @2021 0610
              @导出课程标准	*/
            exportkcbz() {
                this.$api.courseStandard.KcbzKcbzzb.export({
                    data: {
                        "kk_kcbzbh": this.BH,
                    }
                }).then(response => {
                    if (response.data == true) {

                        const fileName = "KCBZ" + this.BH + ".xls";
                        const fileUrl = globalConfig.HOST_PROXY_ADMIN + '/api/file/tempFile/' + fileName;
                        let exist = this.isExistFile(fileUrl);
                        if (exist) {
                            this.downloadFile(fileUrl, fileName);
                        } else {
                            this.$notify({
                                title: "错误",
                                message: "文件不存在，如有疑问请联系管理员！",
                                type: "error",
                                duration: 3000,
                            });
                        }
                    } else {
                        this.$notify({
                            title: '导出',
                            message: '导出失败',
                            type: 'error',
                            duration: 1500,
                        });
                    }
                }).catch(error => {
                    console.log(error);
                });
            },
            //2021 0506 lbj 数据加载方法
            loadMsg() {
                let that = this
                //WHY1数据加载
                this.$api.courseStandard.KcbzKcbzzb.queOne({
                    data: {
                        kk_kcbzbh: this.BH
                    }
                }).then(response => {
                    const courseStandardInfo = response.data.data.MSG;

                    if (courseStandardInfo.kk_tjzt == "0") {
                        this.courseStandardState = '1';
                    } else if (courseStandardInfo.kk_tjzt == "1" && courseStandardInfo.kk_shzt=='') {
                        this.courseStandardState = '2';
                    } else if (courseStandardInfo.kk_shzt == "1") {
                        this.courseStandardState = '3';
                    } else if (courseStandardInfo.kk_shzt == '2'){
                        this.courseStandardState = '4';
                    }else{
                        this.courseStandardState = '0';
                    }

                    this.BZR = courseStandardInfo.jsmc
                    this.BZRQ = response.data.data.MSG.kk_bzrq
                    this.dqxnxq = courseStandardInfo.kk_qxxn
                    this.KCMB = courseStandardInfo.kk_kcmb
                    this.KCXZ = courseStandardInfo.kk_kcxz
                    this.SJSL = courseStandardInfo.kk_sjsl
                    this.JXHDCK = courseStandardInfo.kk_jxhdck
                    this.SYZY = courseStandardInfo.kk_syzy
                    this.KCZXS = courseStandardInfo.kk_kczxs
                    this.filename = courseStandardInfo.kk_filename
                    this.kk_file = courseStandardInfo.kk_file
                    if (courseStandardInfo.kcmc == undefined || courseStandardInfo.kcmc == null) {
                        courseStandardInfo.kcmc = ""
                    }
                    this.title = courseStandardInfo.kcmc + "课程标准";
                    this.BZRGH = courseStandardInfo.kk_bzr;
                    this.state = courseStandardInfo.kk_state;
                    this.KC = this.BH.substring(this.BH.length - 10, this.BH.length) + "-" + courseStandardInfo.kcmc;
                    this.zxsyz(courseStandardInfo.rpzxs);
                }).catch(error => {
                    console.log(error);
                });
            },
            //2021 0506 lbj 知识点表格数据加载方法
            loadzsdMsg() {
                this.$api.courseStandard.KcbzKcnryyq.queList({
                    data: {
                        kk_kcbzbh: this.BH
                    }
                }).then(response => {
                    this.spanArr1 = [];
                    this.spanArr2 = [];
                    this.spanArr3 = [];
                    this.spanArr4 = [];
                    this.spanArr5 = [];
                    this.spanArr6 = [];
                    this.getSpanArr(response.data.data);
                    this.tableData = response.data.data;
                }).catch(error => {
                    console.log(error);
                });
            },
        },
    }
</script>
<style scoped>
    /*@import "../../assets/css/main.css";*/

    .v-modal {
        z-index: 1000 !important;
    }

    .el-dialog__header {
        font-weight: bold !important;
        border-bottom: 2px rgb(0, 155, 173) solid !important;
    }

    .el-table .cell {
        white-space: pre-line;
    }

    #KCXZ {
        height: 200px
    }

    #SJSL {
        height: 200px
    }

    #KCMB {
        height: 200px
    }

    #KCNRYYQ {
        height: 180px;
        border: none
    }

    #JXHDCK {
        height: 200px
    }

    .fromtitle.new1 {
        text-align: left;
        width: 100%;
        line-height: 50px;
        border-width: 1.5px;
        border-bottom: none;
        display: block;
        font-size: 18px;
        padding: 0 15px;
        border-bottom: 1px solid #dee2e6;
        background: #f6f8f8;
        color: #58666e;
    }

    .dialog-footer {
        margin-top: -15px;
    }

    .el-form--inline .el-form-item__label {
        background-color: #edf1f2;
    }

    .zxstsy {
        padding-left: 20px;
    }

    .status {
        width: 100px;
        height: 40px;
        line-height: 40px;
        color: #ffffff;
        font-size: 16px;
        font-weight: bold;
        border: 2px solid;
        border-radius: 8px;
        margin-left: 10px;
        text-align: center;
    }

    .scrollArea /deep/.el-scrollbar .is-vertical {
        width: 15px;
    }

    .fileName {
        margin: 20px 0 20px 0;
        font-size: 16px;
    }
</style>



// WEBPACK FOOTER //
// criterion_for_curriculumShow.vue?011c4abc